module.exports = "/static/assets/dcd4e99c8ddf7634ce04803950b7e266.png";